/* eslint-disable */
console.log('🔥 key_campaigns_carousel loaded');
import 'jquery';
import Flickity from 'flickity';

const key_campaigns_carousel = (function() {

  // Initialize Flickity carousel
  const init = () => {
    const carousel = document.querySelector('.KeyCampaigns-campaigns');
    if (carousel) {
      let flkty = new Flickity(carousel, {
        cellAlign: 'center',
        contain: true,
        wrapAround: true,
        pageDots: true,
        prevNextButtons: true,
        draggable: true,
        setGallerySize: true,
        adaptiveHeight: false
      });
      
      // Equalize heights after initialization
      setTimeout(() => {
        equalizeCardHeights();
        flkty.resize();
      }, 100);
      
      // FORCE POSITIONING OVERRIDE - Fight Flickity's JavaScript positioning
      flkty.on('ready', function() {
        forceDotsPositioning();
      });
      
      flkty.on('change', function() {
        forceDotsPositioning();
      });
      
      flkty.on('resize', function() {
        forceDotsPositioning();
      });
      
      // Aggressively override positioning every 200ms
      setInterval(() => {
        forceDotsPositioning();
      }, 200);
      
      // Handle window resize
      window.addEventListener('resize', () => {
        setTimeout(() => {
          equalizeCardHeights();
          forceDotsPositioning();
          flkty.resize();
        }, 100);
      });
      
      console.log('✅ Flickity carousel initialized with positioning override');
    }
  };

  // Force dots to use our positioning instead of Flickity's
  const forceDotsPositioning = () => {
    const dots = document.querySelector('.KeyCampaigns-campaigns .flickity-page-dots');
    if (dots) {
      // Remove all inline styles that Flickity adds
      dots.removeAttribute('style');
      
      // Force our CSS positioning with maximum priority
      dots.style.setProperty('position', 'static', 'important');
      dots.style.setProperty('margin-top', '30px', 'important');
      dots.style.setProperty('margin-left', 'auto', 'important');
      dots.style.setProperty('margin-right', 'auto', 'important');
      dots.style.setProperty('left', 'auto', 'important');
      dots.style.setProperty('right', 'auto', 'important');
      dots.style.setProperty('bottom', 'auto', 'important');
      dots.style.setProperty('top', 'auto', 'important');
      dots.style.setProperty('transform', 'none', 'important');
      dots.style.setProperty('width', '100%', 'important');
      dots.style.setProperty('text-align', 'center', 'important');
      dots.style.setProperty('display', 'block', 'important');
    }
  };

  // Function to equalize card heights
  const equalizeCardHeights = () => {
    const carousel = document.querySelector('.KeyCampaigns-campaigns');
    const cards = document.querySelectorAll('.KeyCampaigns-campaign');
    if (cards.length === 0) return;
    
    // Set a reasonable max-height on the carousel container to prevent expansion
    carousel.style.setProperty('max-height', '600px', 'important');
    
    // Reset heights first
    cards.forEach(card => {
      card.style.height = 'auto';
      card.style.minHeight = 'auto';
    });
    
    // Find the tallest card
    let maxHeight = 0;
    cards.forEach(card => {
      const height = card.offsetHeight;
      if (height > maxHeight) {
        maxHeight = height;
      }
    });
    
    // Apply max height to all cards WITHOUT !important
    cards.forEach(card => {
      card.style.height = Math.min(maxHeight, 500) + 'px'; // Cap at 500px max
      card.style.minHeight = Math.min(maxHeight, 500) + 'px';
    });
    
    console.log('📏 Card heights equalized to:', Math.min(maxHeight, 500) + 'px');
  };

  return {
    init: init,
  };
})();

$(document).ready(function() {
  key_campaigns_carousel.init();
});
/* eslint-enable */


// WEBPACK FOOTER //
// ./scripts/components/key_campaigns_carousel.js